import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors, stateKeys } from '../../../../model';
import { stepKeys } from '../../../../config/step';
import { uploadingFieldNames } from '../../../../config/uploadingStep';
import GoToBtn, { iconsPos } from '../../../ui/GoToBtn/GoToBtn';
import StepContainer from '../../../ui/StepContainer/StepContainer';
import { settingStepFields } from '../../../../config/import';
import SettingStepMappingSelect from '../../../controllers/SettingStepMappingSelect/SettingStepMappingSelect';
import { returnTypesValueKeys, useTypes } from '../../../../api/types';

const { stepChangeAction, goToPreviewAction } = actions;
const { selectUploadingStepValue, selectStateValue, selectCanGoToPreviewStep } =
  selectors;

const importTypeSelector = (state) =>
  selectUploadingStepValue(state, uploadingFieldNames.importType);
const sheetDataSelector = (state) =>
  selectStateValue(state, stateKeys.workbookSheetData);
const settingValuesSelector = (state) =>
  selectStateValue(state, stateKeys.settingValues);

const chunkArray = (array, size) => {
  return array.reduce((result, _, index) => {
    if (index % size === 0) {
      result.push(array.slice(index, index + size));
    }
    return result;
  }, []);
};

const Fields = () => {
  const importType = useSelector(importTypeSelector);
  const sheetData = useSelector(sheetDataSelector);

  const settingValues = useSelector(settingValuesSelector);

  const fieldChunks = useMemo(
    () => chunkArray(Object.values(settingStepFields[importType] || {}), 2),
    [importType]
  );

  const selectedValues = useMemo(
    () => new Set(settingValues.values()),
    [settingValues]
  );

  return fieldChunks.map((fields, index) => (
    <StepContainer.Row key={index}>
      {fields.map(({ name, label, optional }) => (
        <SettingStepMappingSelect
          key={name}
          name={name}
          label={label}
          optional={optional}
          values={selectedValues}
          columns={Object.entries(sheetData[0])}
        />
      ))}
    </StepContainer.Row>
  ));
};

const GoToPreviewStep = () => {
  const importType = useSelector(importTypeSelector);
  const enabled = useSelector(selectCanGoToPreviewStep);

  const types = useTypes({
    importType,
    returnValueType: returnTypesValueKeys.data,
  });

  const dispatch = useDispatch();

  const handleClick = () => dispatch(goToPreviewAction(types));

  return (
    <GoToBtn
      text="Шаг 3: предварительный просмотр"
      iconPos={iconsPos.right}
      onClick={handleClick}
      disabled={!enabled}
    />
  );
};

const SettingStep = () => {
  const dispatch = useDispatch();
  const gotToUploadingStep = () =>
    dispatch(stepChangeAction(stepKeys.uploading));

  return (
    <>
      <StepContainer.Title>Шаг 2 из 3: настройка полей</StepContainer.Title>
      <StepContainer.BoundingWrap grow>
        <Fields />

        <StepContainer.Footer>
          <GoToBtn
            iconPos={iconsPos.left}
            text="Шаг 1: загрузка файла"
            onClick={gotToUploadingStep}
          />
          <GoToPreviewStep />
        </StepContainer.Footer>
      </StepContainer.BoundingWrap>
    </>
  );
};

export default SettingStep;
